/* eslint-disable no-console -- unico modulo autorizado a llamar console.*, enrutado condicionalmente por ambiente */
import * as Sentry from '@sentry/react';

const isDev = import.meta.env.DEV;

export const logger = {
  error: (...args: unknown[]) => {
    if (isDev) {
      console.error(...args);
      return;
    }
    // Patron dominante en toda la app: logger.error('etiqueta legible', error).
    // Antes, si args[0] era un string, se creaba un Error NUEVO con ese string
    // como mensaje y el error real (con su mensaje/stack reales) quedaba
    // enterrado en extra.context — Sentry mostraba titulos inutiles como
    // "Error: Error:" en vez del error de verdad. Ahora: si CUALQUIER
    // argumento es un Error real, se captura ese como la excepcion principal
    // (preserva tipo/mensaje/stack reales); la etiqueta legible queda como
    // extra.label, buscable pero sin tapar el error real. Mismo patron que
    // ya usa el logger del backend (supabase/functions/_shared/logger.ts).
    const errorArg = args.find((a): a is Error => a instanceof Error);
    const label = typeof args[0] === 'string' ? args[0] : undefined;

    if (errorArg) {
      Sentry.captureException(errorArg, {
        extra: { label, context: args.filter((a) => a !== errorArg) },
      });
      return;
    }

    const err = new Error(
      typeof args[0] === 'string' ? args[0] : JSON.stringify(args[0])
    );
    Sentry.captureException(err, {
      extra: { context: args.slice(1) },
    });
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.info(...args);
  },
};
